import { ImageItem, Template, FileItem } from 'REDUCERS/image'
import { createAction } from 'typesafe-actions'

export const addImage = createAction('ADD_IMAGE')<ImageItem>()
export const updateImage = createAction('UPDATE_IMAGE')<Partial<ImageItem>>()
export const removeImage = createAction('REMOVE_IMAGE')<number>()
export const removeImages = createAction('REMOVE_IMAGES')<number[]>()
export const removeAllImage = createAction('REMOVE_ALL_IMAGE')()
export const setActiveImage = createAction('SET_ACTIVE_IMAHE')<number>()

export const updateCropSize = createAction('UPDATE_CROP_SIZE')<
  Partial<Template['crop']>
>()

export const changeTemplate = createAction('CHANGE_TEMPLATE')<Partial<Template>>()
export const addFiles = createAction('ADD_FILE')<{ files: FileItem[]; index: number }>()
export const setCompareIndex = createAction('SET_COMPARE_INDEX')<number>()
export const changeTemplageMode = createAction('CHANGE_TEMPLATE_MODE')<
  Partial<Template>
>()

export const resetTemplate = createAction('RESET_TEMPLATE')()

export const setApplyAll = createAction('SET_APPLY_ALL')()

export const setApplyAllActive = createAction('SET_APPLY_ALL_ACTIVE')()

export const setApplyAllStatic = createAction('SET_APPLY_ALL_STATIC')()

export const getCutImage = createAction('GET_CUT_IMAGE')()

export const getPreviewImages = createAction('GET_PREVIEW_IMAGES')()

export const updateFile = createAction('UPDATE_FILE')<FileItem>()

export const clearAllFiles = createAction('CLEAR_ALL_FILES')()
